<template>
    <div>
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a href="/event/home">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>管理者一覧</b>
                            </div>
                        </div>
                        <div class="col-4">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="container" style="margin-top:60px;">
                    <div class="row">
                        <div class="col text-end">
                            <a type="button" class="btn btn-luna-outline" :href="'/event/admin/mail/add/' + event_id"
                                style="padding:8px 12px;border-radius: 10px;font-size:14px">
                                管理者権限を共有
                            </a>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col px-0">
                            <table class="table table-borderless">
                                <thead>
                                    <tr style="background:#C6C4FF">
                                        <td scope="col">メールアドレス</td>
                                        <td scope="col">権限</td>
                                        <td scope="col"></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="align-middle" v-for="(member, index) in event_members" :key="index">
                                        <td scope="col">{{ member.admin_mail }}</td>
                                        <td scope="col">{{ member.status_value }}</td>
                                        <td scope="col" v-if="member.status == 1"></td>
                                        <td scope="col" v-else>
                                            <a @click="rmMember(member.id)" type="button" class="btn btn-secondary">削除</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br>
                    <br />
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event_id: "",
            event_members: [],
        };
    },
    methods: {
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.fetchEventMember(this.$route.params['eid'])
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async fetchEventMember(eid) {
            await axios.get("/api/event/admin/mail/list/" + eid)
                .then(
                    (response) => {
                        this.event_members = response.data.event_members
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("管理者の取得に失敗しました")
                    }
                })
        },
        async rmMember(id) {
            await axios.get("/api/event/admin/mail/rm/" + id)
                .then(
                    (response) => {
                        this.fetchEventMember(this.$route.params['eid'])
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("管理者の削除に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.event_id = this.$route.params['eid']
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.event_id = this.$route.params['eid']
            }
        }
        else {
            this.isAuth()
            this.event_id = this.$route.params['eid']
        }
    },
};
</script>

<style scoped>
.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
